
import Vue from 'vue';
import { Card } from './styles';

export default Vue.extend({
  components: { Card },
  props: {
    url: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      isVisible: false,
    };
  },
});
